/* 🤖 this file was generated by script */
export const wiconPower01 = {
  name: 'power_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 2v10m6.36-5.36a9 9 0 11-12.73 0"/></svg>`,
};
